import { RequireChildrenFor } from "@omni/types/components/utils/children.types";
import { cn } from "@omni/utils/styles";

import { useSearchResultsContext } from "@/components/Search/SearchResults/context/searchResults.context";
import * as ScrollPositionService from "@/services/scrollPosition.service";
import RenderCallback from "@/utils/renderCallback";

type WrapperProps = RequireChildrenFor<{}>;

const Wrapper = ({ children }: WrapperProps) => {
    const { showFacets } = useSearchResultsContext();

    const afterRender = () => {
        ScrollPositionService.scrollToLastPosition();
    };

    return (
        <section
            className={cn(
                "tw:relative tw:grid tw:gap-8 tw:grid-cols-[1fr]",
                "tw:lg:grid-cols-[2fr_8fr]",
                {
                    "tw:lg:grid-cols-[1fr]": !showFacets
                }
            )}
        >
            <RenderCallback callback={afterRender}>{children}</RenderCallback>
        </section>
    );
};

export { Wrapper };
